import {
  DeleteOutlined,
  EditOutlined,
  FolderAddOutlined,
} from "@ant-design/icons";
import { Card, Popover, Tooltip } from "antd";
import React, { useState } from "react";
import DeleteScaleUnitApi from "../../api/scale-unit/DeleteScaleUnitApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import ConfirmationModal from "../modal/ConfirmationModal";
import EditScaleUnitModal from "../modal/edit/EditScaleUnitModal";

function ScalesUnitCard(props) {
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState("");
  const [deleteScaleUnitId, setDeleteScaleUnitId] = useState("");

  async function deleteScaleUnit() {
    const apiResponse = await DeleteScaleUnitApi(deleteScaleUnitId);

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", apiResponse.message);
      if (props.scales?.length === 1) {
        props.changePage(props.page - 1);
      } else {
        props.changePage(props.page);
      }
    } else {
      openNotificationError(
        "bottomRight",
        `Couldn't ${deleteModal}. Try again later.`
      );
    }
    setDeleteScaleUnitId("");
  }

  return (
    <>
      <Card
        size="small"
        title={
          <div className="flex items-center justify-between truncate">
            {props.record?.unitName}
            <div className="flex items-center gap-1">
              <Tooltip title={"Edit"}>
                <div
                  onClick={() => {
                    setEditModal(true);
                  }}
                  className="text-blue-500 hover:text-blue-600 cursor-pointer"
                >
                  <EditOutlined />
                </div>
              </Tooltip>
              {props?.record?.canDelete ? (
                <Tooltip title={"Delete"}>
                  <div
                    onClick={() => {
                      setDeleteModal("delete");
                      setDeleteScaleUnitId(props?.record?.id);
                    }}
                    className="text-red-500 hover:text-red-600 cursor-pointer"
                  >
                    <DeleteOutlined />
                  </div>
                </Tooltip>
              ) : props.record?.canArchive ? (
                <Tooltip title={"Archive"}>
                  <div
                    onClick={() => {
                      setDeleteModal("archive");
                      setDeleteScaleUnitId(props?.record?.id);
                    }}
                    className="text-orange-500 hover:text-orange-600 cursor-pointer"
                  >
                    <FolderAddOutlined />
                  </div>
                </Tooltip>
              ) : (
                <Popover
                  placement="left"
                  content={"This plan group can't be deleted"}
                  trigger="hover"
                >
                  <div className="text-gray-500">
                    <FolderAddOutlined />
                  </div>
                </Popover>
              )}
            </div>
          </div>
        }
        bordered={false}
        key={props.record?.id}
      >
        <div>Symbol: {props.record?.symbol || "-"}</div>
        <div> Abb: {props.record?.abbreviation || "-"}</div>
      </Card>
      <EditScaleUnitModal
        visible={editModal}
        handleCancel={() => {
          setEditModal(false);
        }}
        unit={props.record}
        handleOk={() => props.changePage(props.page)}
      />
      <ConfirmationModal
        visible={deleteModal}
        handleCancel={() => {
          setDeleteModal("");
          setDeleteScaleUnitId("");
        }}
        handleOk={() => deleteScaleUnit()}
        text={`Are you sure want to ${deleteModal} this unit?`}
        title={deleteModal?.charAt(0).toUpperCase() + deleteModal?.slice(1)}
      />
    </>
  );
}
export default ScalesUnitCard;
